module.exports = __webpack_public_path__ + "img/share-task-icon.ae47b3f3.png";